export const STATUS_CLASS = {
  Present: "pill pill-present",
  Late: "pill pill-late",
  "Late Arrival": "pill pill-late-arrival",
  Absent: "pill pill-absent",
  Pending: "pill pill-pending",
  "Signed Out": "pill pill-signed-out",
  "Planned Absence": "pill pill-planned",
  "—": "text-slate-300 font-mono text-lg leading-none",
};

export default function StatusPill({ status, prior }) {
  const cls = STATUS_CLASS[status] || "pill pill-pending";
  // Off-season placeholder — render a clean dash without the pill chrome
  if (status === "—") {
    return <span className={cls} data-testid="status-off-season" title="Outside camp window — attendance not tracked">—</span>;
  }
  return (
    <span className={cls} data-testid={`status-pill-${(status || "").toLowerCase().replace(/\s+/g, "-")}`}>
      {status}
      {status === "Signed Out" && prior && (
        <span className="ml-1 font-normal opacity-80">(was {prior})</span>
      )}
    </span>
  );
}
